// en-US.js
import { headerEN } from "./language/header";
import { footerEN } from "./language/footer";
import { homeEN } from "./language/home";
import { joinUstitleEN, WorkModeEN, WelfareEN, jobEN } from "./language/joinUs";
import { aboutUsEN } from "./language/aboutUs";
import { technologyEN } from "./language/technology";

import { productCenterGaiAViewEN } from "./language/productCenterGaiAView";
import { productCenterPDRHeaViewEN } from "./language/productCenterPDRHeaView";
import { productCenterHiLViewEN } from "./language/productCenterHiLView";
import { productCenterDriveViewEN } from "./language/productCenterDriveView";
import { productCenterSiLViewEN } from "./language/productCenterSiLView";
import { productCentermeidushaViewEN } from "./language/productCentermeidushaView";
import { productCenterHerculesViewEN } from "./language/productCenterHerculesView";
import { productCenterUranusEN } from "./language/productCenterUranus";
import { productCenterRobotEN } from "./language/productCenterRobot";
import { modelSharePlatformEN } from "./language/ecosphere/modelSharePlatform";
import { ecologicalCooperationSharePlatformEN } from "./language/ecosphere/ecologicalCooperationSharePlatform";
import { fullScaleAutonomousDrivingEN } from "./language/ecosphere/fullScaleAutonomousDriving";

export default {
  header: headerEN,
  footer: footerEN,

  home: homeEN,
  joinUstitle: joinUstitleEN,
  WorkMode: WorkModeEN,
  Welfare: WelfareEN,
  job: jobEN,
  aboutUs: aboutUsEN,
  technology: technologyEN,
  productCenterGaiAView: productCenterGaiAViewEN,
  productCenterPDRHeaView: productCenterPDRHeaViewEN,
  productCenterHiLView: productCenterHiLViewEN,
  productCenterDriveView: productCenterDriveViewEN,
  productCenterSiLView: productCenterSiLViewEN,
  productCentermeidushaView: productCentermeidushaViewEN,
  productCenterHerculesView: productCenterHerculesViewEN,
  productCenterUranus: productCenterUranusEN,
  productCenterRobot: productCenterRobotEN,
  ecosphereModelSharePlatform: modelSharePlatformEN,
  ecosphereCooperationSharePlatform: ecologicalCooperationSharePlatformEN,
  ecosphereFullScaleAutonomousDriving: fullScaleAutonomousDrivingEN,
};
